import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2UpdateProcedureService {
    constructor(private datatask: DataTaskService) {}

    public async getSettings(): Promise<P2UpdateProcedureSettingsGet> {
        return (await this.datatask.Post(1601))[0];
    }

    public async listProcedures(): Promise<P2UpdateProcedureItem[]> {
        return this.datatask.Post(207);
    }

    public async getProcedure(params: GetP2UpdateProcedureParams): Promise<P2UpdateProcedureGet> {
        return (await this.datatask.Post(208, params))[0];
    }

    public async saveProcedure(procedure: P2UpdateProcedureGet): Promise<void> {
        await this.datatask.Post(209, procedure);
    }
}

export interface P2UpdateProcedureSettingsGet {
    searchtext: string;
}

export interface P2UpdateProcedureItem extends Item {
    item_state?: string;
}

export interface GetP2UpdateProcedureParams {
    p2_updateprocedure_keyno: string;
}

export interface P2UpdateProcedureGet {
    p2_updateprocedure_keyno: string;
    proc_name: string;
    is_like: '0' | '1';
    but_not_like: '0' | '1';
    is_equal_to: '0' | '1';
    but_not_equal_to: '0' | '1';
    reg_datetime: string;
}
